var exports = {
  "SL": "PeriodNavigationLink__YPwJud",
  "cp": "Selected__4WTupV",
  "oM": "PeriodNavigation__YY4irT",
};

module.exports = exports;
